var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('update-authority-dialog',{attrs:{"value":_vm.court,"title":"Amtsgericht bearbeiten","updateAuthority":_vm.update,"dialog":_vm.iDialog},on:{"update:dialog":function($event){_vm.iDialog=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }